import { render, staticRenderFns } from "./EventReviewPurchaseModal.vue?vue&type=template&id=a7a79e84&scoped=true&"
import script from "./EventReviewPurchaseModal.vue?vue&type=script&lang=js&"
export * from "./EventReviewPurchaseModal.vue?vue&type=script&lang=js&"
import style0 from "./EventReviewPurchaseModal.vue?vue&type=style&index=0&id=a7a79e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a79e84",
  null
  
)

export default component.exports